import { Button, Modal } from 'react-bootstrap';

interface IModalValuesComponentProps {
    show: boolean,
    toggleShow: () => void,
    setResponse: React.Dispatch<React.SetStateAction<boolean>>,
    changing: string
}

const ModalConfirmHistoricComponent = ({show, toggleShow, setResponse, changing}: IModalValuesComponentProps) => {
    const handleClose = () => {
        setResponse(false);
        toggleShow();
    }
    const handleCloseWithResponse = () => {
        setResponse(true);
        toggleShow();
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Remover atribuições de linhas do grants?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Ao mudar {changing == "progress" ? "o Progresso para 'não' " : "a Eligibilidade para outro tipo que não seja 'Elegível' "}, 
                este projeto perderá as atribuições, caso tenham sido feitas, de linhas do grants!
            </Modal.Body>
            <Modal.Footer>
                <Button className='btn btn-primary' onClick={handleClose}>
                    Cancelar
                </Button>
                <Button className='btn btn-secondary' onClick={handleCloseWithResponse}>
                    Continuar mesmo assim
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfirmHistoricComponent;